import { Delete, Get, Post, Put, getAPIUrl } from "../../../services/apiMethod";
import { Vendorendpoint } from "./VendorEndpoints";

// export const getVendorsDetails = (param = "") => {
//   const url = getAPIUrl(Vendorendpoint.getVendorsDetails, param);
//   return Get(url);
// };
export const updateActivationStatus = (data, param = "") => {
  const url = getAPIUrl(Vendorendpoint.updateActivationStatus, param);
  return Put(url, data);
};

// export const deleteSelectedCategory = (param = "") => {
//   const url = getAPIUrl(Vendorendpoint.deleteSelectedCategory, param);
//   return Delete(url, param);
// };
